(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/welcome/assets/javascripts/welcome-new-player.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/welcome/assets/javascripts/welcome-new-player.js');
'use strict';

const {
  urlMapping
} = svs.core;
const {
  Button
} = svs.ui;
const {
  clx
} = svs.components.lbUtils;
const {
  WelcomeNewPlayerStepSection
} = svs.marketplace.components.welcome;
const {
  Hero
} = svs.components.marketplace.hero;
const {
  Link
} = ReactRouterDOM;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_MD
} = svs.components.lbUtils.useMediaQuery;
const {
  getOptimalWidth
} = svs.utils;

const WelcomeNewPlayer = _ref => {
  var _svs$marketplace$data, _svs$marketplace$data2, _svs$marketplace$data3, _svs$marketplace$data4, _svs$marketplace$data5, _svs$marketplace$data6;
  let {
    linkTo,
    isAuthenticated
  } = _ref;
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const hasHeroData = Boolean(svs.marketplace.data.heroData && svs.marketplace.data.heroData.teamHero);
  const availableWidths = (_svs$marketplace$data = svs.marketplace.data.heroData) === null || _svs$marketplace$data === void 0 ? void 0 : (_svs$marketplace$data2 = _svs$marketplace$data.teamHero) === null || _svs$marketplace$data2 === void 0 ? void 0 : _svs$marketplace$data2.availableWidths;
  const optimalWidth = getOptimalWidth(availableWidths, 1024);
  const imageUrl = (_svs$marketplace$data3 = svs.marketplace.data.heroData) === null || _svs$marketplace$data3 === void 0 ? void 0 : (_svs$marketplace$data4 = _svs$marketplace$data3.teamHero) === null || _svs$marketplace$data4 === void 0 ? void 0 : _svs$marketplace$data4.imageUrl.replace('{width}', optimalWidth);
  const returnUrlMapping = 'marketplaceTogether';
  const button = isAuthenticated ? React.createElement(Button, {
    className: "qa-create-team-open-button",
    inverted: true
  }, React.createElement(Link, {
    className: "qa-create-team-link",
    to: linkTo
  }, "Starta ett lag")) : React.createElement("a", {
    className: "btn btn-default btn-green qa-login-button",
    href: "/logga-in?returnUrl=".concat(urlMapping.get(returnUrlMapping))
  }, React.createElement("span", {
    className: "btn-link-text"
  }, "Logga in"));
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "bg-sport-100 marketplace-full-width padding-v-2",
    "data-testid": "qa-mkp-team-welcome"
  }, hasHeroData ? React.createElement(Hero, {
    className: clx('team-list-hero', {
      'marketplace-hero-no-image': !imageUrl
    }),
    height: isSmall ? 350 : 500,
    horizontal: "center",
    imageUrl: "".concat(svs.core.config.data.svsconfig.cdn2).concat(imageUrl),
    vertical: "middle"
  }, React.createElement("div", {
    className: "marketplace-hero-inner-content"
  }, React.createElement("h2", {
    className: "marketplace-hero-title"
  }, (_svs$marketplace$data5 = svs.marketplace.data.heroData) === null || _svs$marketplace$data5 === void 0 ? void 0 : (_svs$marketplace$data6 = _svs$marketplace$data5.teamHero) === null || _svs$marketplace$data6 === void 0 ? void 0 : _svs$marketplace$data6.title), React.createElement("div", {
    className: "marketplace-hero-button-container"
  }, React.createElement(Button, {
    className: "qa-marketplace-create-team",
    size: 300
  }, "Skapa lag"), React.createElement(Button, {
    className: "qa-marketplace-login marketplace-button-like-link",
    inverted: true,
    transparent: true
  }, "Logga in")))) : null, React.createElement("div", {
    className: "f-center welcome-cramped-container"
  }, React.createElement("h2", {
    className: "f-900 margin-top-1"
  }, "Starta ett lag!"), React.createElement("p", {
    className: "f-400 margin-bottom-2"
  }, "Att spela tillsammans \xE4r inte bara roligt - det \xF6kar \xE4ven din vinstchans!"), button)), React.createElement("div", {
    className: "f-center padding-v-2 bg-sport-100"
  }, React.createElement("h2", {
    className: "f-800"
  }, "S\xE5 h\xE4r spelar ni i laget:"), React.createElement(WelcomeNewPlayerStepSection, {
    headline: "1. V\xE4lj spelomg\xE5ng",
    icon: "nav-games",
    text: "Best\xE4m vilket spel ni vill spela och hur mycket varje andel ska kosta."
  }), React.createElement(WelcomeNewPlayerStepSection, {
    headline: "2. Samla in pengar",
    icon: "money",
    text: "Medlemmarna k\xF6per andelar tills ni har tillr\xE4ckligt att spela f\xF6r."
  }), React.createElement(WelcomeNewPlayerStepSection, {
    headline: "3. L\xE4mna in spelet",
    icon: "trophy",
    text: "Fixa raden och l\xE4mna in! \xD6verskjutande pengar f\xE5r ni tillbaka."
  }), React.createElement("div", {
    className: "margin-3"
  }, button)));
};
setGlobal('svs.marketplace.components.welcome.WelcomeNewPlayer', WelcomeNewPlayer);

 })(window);